import {postAjax,getAjax}  from "../common/axios.js"

//登录
export const login = params => {
    return postAjax('/api/system/login',params);
}

//获取菜单
export const getUserMenuListJson = params => {
	return getAjax('/api/menu/getUserMenuListJson',params);
}

// 同步登录
export const loginByToken = params => {
	return postAjax('/api/system/nologin/loginByToken',params);
}

